var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-map-box"},[_c('div',{staticClass:"map-content",attrs:{"id":"scatterMap"}}),_c('div',{staticClass:"map-darkcorner"})])}]

export { render, staticRenderFns }